// extracted by css-extract-rspack-plugin
export default {"SanitizedHtml":"title-module__SanitizedHtml__zYKoP","Link":"title-module__Link__PEOd4","SanitizedHtml_1":"title-module__SanitizedHtml_1__GLq2j"};